module.exports = __webpack_public_path__ + "static/media/ImageDefaultDesktop.fd988ef2.png";